import AdditionalDocumentsDropZone from 'components/AdditionalDocumentsDropZone/container';

export default AdditionalDocumentsDropZone;
